/**
 * Detects the user's preferred language from the browser/OS settings.
 * Maps browser language codes to supported application locales.
 * 
 * @param {string[]} supportedLocales - Array of supported locale codes
 * @returns {string} The detected locale code
 */
export function detectBrowserLanguage(supportedLocales = ['en', 'es', 'ca', 'gl', 'eu']) {
  // Get browser languages in order of preference
  const browserLanguages = navigator.languages || [navigator.language || navigator.userLanguage || 'en']
  
  for (const lang of browserLanguages) {
    // Extract primary language code (e.g., 'en-US' -> 'en')
    const primaryLang = lang.split('-')[0].toLowerCase()
    
    // Check if the primary language is supported
    if (supportedLocales.includes(primaryLang)) {
      return primaryLang
    }
    
    // Check full language code (e.g., 'ca-ES' -> 'ca')
    const fullLang = lang.toLowerCase()
    if (supportedLocales.includes(fullLang)) {
      return fullLang
    }
  }
  
  // Default to English if no match found
  return 'en'
}
